const Card = ({ header, description }) => {
    return (
        <div className="card p-3" style={{borderRadius: '8px', letterSpacing: '1px', textTransform: 'uppercase'}}>
            <div style={{color: "#919496", fontSize: '11px'}}>{header}</div>
            <div style={{fontSize: '15px', fontWeight: 500}}>{description}</div>
        </div>
    )
}
export default Card;